// extracted by mini-css-extract-plugin
module.exports = {"ChainCardWrapper":"ChainCard_ChainCardWrapper__2i2Tn","ChainImage":"ChainCard_ChainImage__1wkcS"};